'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = exports.physics = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var physics = exports.physics = function () {
  var base = {
    stiffness: 1000,
    damping: 60,

    precision: 0.99
  };

  var standard = (0, _extends3.default)({}, base);

  var fast = (0, _extends3.default)({}, base, {
    stiffness: base.stiffness * 2
  });

  return { standard: standard, fast: fast };
}();

var css = exports.css = {
  outOfTheWay: 'transform 0.2s cubic-bezier(0.2, 0, 0, 1)'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/animation.js
// module id = 932
// module chunks = 0